import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_CANCELADO } from 'utils/constants';

export const baseURI = '/relojchecador/incidencia-relacion/';

/**
 * GET Incidencia Relaciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasRelacionesPag = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Incidencia Relaciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasRelaciones = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencia Relaciones
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaRelacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Incidencia Relaciones
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaRelacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Incidencia Relaciones
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaRelacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Incidencia Relaciones
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaRelacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Incidencia Relaciones
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarIncidenciaRelacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * CANCELAR Incidencia Relaciones
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const cancelarIncidenciaRelacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_CANCELADO });
    onSuccess(response, 'Cancelado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * REACTIVAR Incidencia Relaciones
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const reactivarIncidenciaRelacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_ACTIVO });
    onSuccess(response, 'Reactivado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
